// Template Library (NDIS Audit Readiness Centre) — UI access rules mirroring the backend. Server-side permissions stay authoritative.
export const LIBRARY_BROWSE_ANY = ['forms.library_import', 'forms.library_admin', 'forms.manage'];

export const canBrowseLibrary = (has) => has('forms.view') && LIBRARY_BROWSE_ANY.some(has);
export const canImportLibrary = (has) => canBrowseLibrary(has) && has('forms.library_import');
// UI gate is forms.library_admin only; the backend additionally requires platform cross-organisation authority (403 LIBRARY_ADMIN_REQUIRED).
export const canAdminLibrary = (has) => has('forms.view') && has('forms.library_admin');

export function libraryError(e) {
  const d = e?.response?.data;
  const err = d?.error || d?.detail?.error || null;
  const detail = d?.detail;
  return {
    status: e?.response?.status ?? null,
    code: err?.code || detail?.code || null,
    message: err?.message || detail?.message || (typeof detail === 'string' ? detail : null) || 'Request failed. Please try again.',
    details: err?.details || detail?.details || {},
  };
}
